import oAxiosInstance from "config/Axios";

export const apiCallGetAllIndicators = (sFilter = "") => {
  return oAxiosInstance.get(`indicadoresfacturacion/${sFilter}`);
};
